export let connection_string;
//export let image_url;
// const PORT = 7081;
if (window.location.hostname === "localhost") {
  connection_string = process.env.REACT_APP_API_URL;
} else {
  connection_string = process.env.REACT_APP_API_URL;
}
